<template>
    <div class="filter-items">
        <div class="filter-name">{{sm.name}}</div>
            <div :class="{isInput:true,errorInput:inputIsError}" v-if="sm.isInput == true">
            <input class="minPrice" type='number' pattern="\d*" placeholder="最低价格" @blur="inputChange(sm,_index)">
            <span>—</span>
            <input class="maxPrice" type='number' pattern="\d*" placeholder="最高价格" @blur="inputChange(sm,_index)">
        </div>
        <div class="filter-item">
            <span v-for="(sidemenu, index) in sm.detailList" class="item-operation" @click="clickFilterbar(sm, _index, index)" :class="{'multi-selected': sidemenu.selectIndex == index}" :key="index">
                {{ sidemenu.name }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            sm: {
                type: Object
            },
            thisIndex: Number||String,
        },
        data() {
            return {
                _index: '',
            }
        },
        methods: {
            clickFilterbar(v, I, i){
                this.$emit('clickFilterbar',v,I,i)
            }
        },
        mounted(){
            this._index = this.thisIndex;
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FilterItems.vue